import Projection from "../../Projection";

export default class ProjectionSave {
    constructor() {        
    }

    /**
     * @param {Projection} projection 
     * @returns {Object}
     */
    static generateSave(projection) {
        const saveState = {};

        saveState.gridCenter = {
            x: projection.gridCenter.x,
            y: projection.gridCenter.y
        };

        saveState.zoom = projection.zoom;

        saveState.centerOnCharacter = projection.stayCenteredOnCharacter;

        return saveState;
    }

    /**
     * @param {Projection} projection 
     * @param {Object} saveState 
     */
    static loadSave(projection, saveState) {
        if (!saveState) {
            return;
        }

        projection.setGridCenter(saveState.gridCenter.x, saveState.gridCenter.y);

        projection.setZoom(saveState.zoom);

        projection.stayCenteredOnCharacter = false;
        if (saveState.centerOnCharacter) {
            projection.stayCenteredOnCharacter = true;
        }
    }
}